import { LinearProgress } from "@material-ui/core";
import useDashboardEditor from "MyDashboards/state/editor";
import { Element } from "MyDashboards/state/editorTypes";
import axios, { AxiosError, AxiosResponse } from "axios";
import React from "react";
import { useQuery } from "react-query";
import { paragraphsToHTML } from "./utils";

const RenderText = (props: {
  el: Element;
  slideNumber: number;
  withText?: string;
}) => {
  const [width, setWidth] = React.useState(0);
  const [height, setHeight] = React.useState(0);
  const factor = useDashboardEditor((s) => s.scaleFactor);
  const templateName = useDashboardEditor((s) => s.templateName);
  const { el } = props;

  const cacheKey = `${Math.round(el.width)}-${Math.round(el.height)}-${
    props.withText || ""
  }-${el.id}-${paragraphsToHTML(el)}-${factor}`;

  const { data, isLoading } = useQuery<
    AxiosResponse<{ png: string }>,
    AxiosError<any>
  >(
    cacheKey,
    async () => {
      return axios({
        url: "report/renderelement",
        method: "POST",
        data: {
          fileName: templateName, //  `/report/templates/${FILE_NAME}.pptx`,
          slideNumber: props.slideNumber,
          element: {
            type: "text",
            value: props.withText || el.rendered?.value || "",
            slideElement: el.tag,
            autofit: false, // el.rendered?.autofit,
            x: el.x,
            y: el.y,
            width: el.width / factor,
            height: el.height / factor,
            paragraphs: props.withText
              ? undefined
              : el.paragraphs && el.paragraphs.length > 0
              ? el.paragraphs
              : undefined,
          },
        },
      });
    },
    { staleTime: Infinity }
  );

  if (!data || isLoading) return <LinearProgress />;
  return (
    <img
      key={el.id}
      src={`data:image/png;base64,${data.data.png}`}
      style={{ pointerEvents: "none", transformOrigin: "top left" }}
      onLoad={(e) => {
        console.log("img load ", e);
        setWidth((e.target as any).naturalWidth * factor);
        setHeight((e.target as any).naturalHeight * factor);
      }}
      width={width}
      height={height}
      alt={props.withText || el.rendered?.value || ""}
    />
  );
};

export default RenderText;
